export default __webpack_public_path__ + "static/media/background3.559021d2.png";